<template>
  <div class="search-page" :style="{top:top+'px'}">
    <div class="top-search flex-center">
      <div class="top-search-box flex-row-align-center radius-clip-5">
        <div class="top-search-box-option-box flex flex-row-justify-space-between flex-row-align-center cursor position-relative">
          <el-select v-model="searchType" class=" mach-width" :popper-append-to-body="false" placeholder="请选择" @change="searchcatechange">
            <el-option
              v-for="item in searchcates"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <img class=" position-absolute" style="right: 0; pointer-events: none;" src="../assets/icon-lib-drop-arrow.png">
        </div>
        <div class="top-search-box-input-box flex-1">
          <input class="font-size-12" type="text" :placeholder="collectionCountText" :value="keyword" @input="inputchange" @keyup.enter="toSearch">
        </div>
        <div class="top-search-box-icon cursor flex-center" @click="toSearch">
          <img src="../assets/icon-lib-coll-search.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import searchModel from '../models/search.js'
import api from '../api/common.js'
import {
  mapState
} from 'vuex'
export default {
  name: 'SearchBar',
  props: {
    top: {
      type: Number,
      default: 70
    },
    type: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      inputValue: searchModel.keyword || '',
      searchcates: [{
        name: '馆藏',
        id: 1
      },
      {
        name: '资源',
        id: 2
      }, {
        name: '用户',
        id: 3
      }
      ],
      searchType: 1,
      collectionCountText: ''
    }
  },
  computed: {
    ...mapState({
      keyword: state => state.search.keyword
    })
  },
  watch: {
    type(newvalue, oldvalue) {
      if (newvalue !== oldvalue) {
        this.searchType = this.type
      }
    }
  },
  created() {
    this.request()
    this.searchType = searchModel.type
  },
  methods: {
    request() {
      const that = this
      api.collectionCount({ tenantId:this.$store.getters.tenantId, type: this.searchType }).then(r => {
        if (that.searchType === 1) {
          that.collectionCountText = '在' + r.data + '条数字馆藏中检索'
        } else if (that.searchType === 2) {
          that.collectionCountText = '在' + r.data + '条多媒体资源中检索'
        } else if (that.searchType === 3) {
          that.collectionCountText = '在' + r.data + '个用户中检索'
        }
      })
    },
    inputchange(e) {
      this.$store.dispatch('search/setKeyword', e.target.value)
    },
    searchcatechange(e) {
      this.request()
      this.$store.dispatch('search/setType', e)
      this.$store.dispatch('search/setKeyword', '')
      this.$emit('catechange', e)
    },
    toSearch() {
      this.$emit('inputfinish')
    },
    changeSearchType(v) {
      this.searchType = v
      this.request()
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style lang="scss" scoped>
::v-deep .el-input__inner {
  font-size: 12px !important;
    color: #264480 !important;
    padding: 0 !important;
    border: none !important;
}
::v-deep .el-input__suffix-inner {
  display: none;
}

/deep/ .el-select-dropdown__item.selected {
  color: #264480 !important;
}
</style>
<style scoped>

.search-page {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 999;
}

.search-page .top-search {
width: 100%;
height: 50px;
background-color: #F3F4F9;
}

.search-page .top-search .top-search-box {
  height: 36px;
  width: 500px;
  background-color: #fff;
  border: 1px solid rgba(26, 59, 128, 0.2);
}

.search-page .top-search .top-search-box .top-search-box-option-box {
  width: 120px;
  height: 20px;
  border-right: 1px solid rgba(36, 54, 95,0.25);
  padding-left: 8px;
}

.search-page .top-search .top-search-box .top-search-box-option-box span:last-child {
  transform: rotate(180deg);
}

.search-page .top-search .top-search-box .top-search-box-input-box {
  padding: 0 10px;
}

.search-page .top-search .top-search-box .top-search-box-input-box input {
  border: none;
  width: 100%;
}

.search-page .top-search .top-search-box .top-search-box-input-box input:focus {
  outline: none;
}

.search-page .top-search .top-search-box .top-search-box-icon img {
  width: 31px;
  height: 31px;
}
/* .el-input__suffix-inner {
    display: none!important;
  }
.el-input__inner {
    font-size: 12px !important;
    color: #264480 !important;
    padding: 0 !important;
    border: none !important;
  } */

input:focus {
  outline: none;
}
</style>
